cb.define(['common/common_VM.Extend.js'], function (common) {
    var PM_pmc_promotionanalysis_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },
        init: function (viewmodel) {
            //合并单元格
            viewmodel.getGridModel().setState("showAggregates", false);
            viewmodel.getGridModel().setState('mergeCells', true);
            viewmodel.getGridModel().setState('mergePosition', 'first');
            viewmodel.getGridModel().on("beforeSetDataSource", function (data) {
                    viewmodel.getGridModel().setColumnState("name", "bMergeCol", true);
                }
            );
        }

    }
    try {
        module.exports = PM_pmc_promotionanalysis_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_promotionanalysis_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_promotionanalysis_VM.Extend.js